module.exports = __webpack_public_path__ + "media/application/images/bonington_slider_bracelet-8854b7a1d7d0e8e6f5664ea356633918.png";